import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import GlassCard from './GlassCard';
import GradientIconBadge from './GradientIconBadge';
import { gradients } from '../../themes/gradients';

/**
 * Card de estatística usado nos dashboards (Início, Financeiro,
 * Relatórios) - vidro + badge de ícone em gradiente + entrada animada
 * (stagger via `index`). Clicável quando `onClick` é passado.
 */
const AnimatedStatCard = ({ icon, gradient = 'blue', label, value, subtitle, onClick, index = 0 }) => {
    const g = gradients[gradient] || gradients.blue;

    return (
        <Box
            component={motion.div}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: index * 0.06, ease: [0.4, 0, 0.2, 1] }}
            sx={{ height: '100%' }}
        >
            <GlassCard accent={g.main} onClick={onClick} sx={{ height: '100%', cursor: onClick ? 'pointer' : 'default' }}>
                <CardContent>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
                                {label}
                            </Typography>
                            <Typography variant="h3" fontWeight={800} sx={{ mt: 0.5, letterSpacing: '-0.02em' }}>
                                {value}
                            </Typography>
                            {subtitle && (
                                <Typography variant="caption" color="text.secondary">
                                    {subtitle}
                                </Typography>
                            )}
                        </Box>
                        <GradientIconBadge icon={icon} gradient={gradient} size={48} />
                    </Stack>
                </CardContent>
            </GlassCard>
        </Box>
    );
};

AnimatedStatCard.propTypes = {
    icon: PropTypes.elementType,
    gradient: PropTypes.oneOf(['blue', 'teal', 'amber', 'coral', 'graphite']),
    label: PropTypes.node,
    value: PropTypes.node,
    subtitle: PropTypes.node,
    onClick: PropTypes.func,
    index: PropTypes.number
};

export default AnimatedStatCard;
